import React, { useEffect, useState } from 'react';
import LoaderRoundedWithText from './LoaderRoundedWithText';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import LoaderRounded from './LoaderRounded';
import ReactPaginate from 'react-paginate';
import * as Icon from 'react-bootstrap-icons';
import { Button, Col, Row, Form } from 'react-bootstrap';
import axios from 'axios';

const CoordinatorPrimeMemberShipCount = () => {

    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(false);
    const [primeMemberData, setPrimememberData] = useState([]);
    const [searchData, setSearchdata] = useState('');


    useEffect(() => {
        getPrimeMembershipList();
    }, [searchData]);

    const getPrimeMembershipList = (currentPage = 1) => {
        setLoading(true); 
        const payload = {
            documentsPerPage: 10,
            page: currentPage,
            mobile: "",
            name: "",
            yin_id: "",
            searchTitle: searchData,
        };
        axios.post(process.env.REACT_APP_APIURL + `/subscription/getSubscriptionCoordinatorCount`, payload)
            .then((res) => {
                setPrimememberData(res?.data?.data || []); 
                setTotalPages(res?.data?.noOfPages || 0);
                setPage(currentPage);
            })
            .catch((error) => {
                console.log('error', error);
                setPrimememberData([]); 
            })
            .finally(() => {
                setLoading(false); 
            });
    };

    const filteredData = primeMemberData.filter(member => member.city !== null);

    let primeMember = '';
    if (filteredData?.length > 0) {
        primeMember = filteredData.map((member, index) => (
            <tr key={index}>
                <td>{index + 1 + (page - 1) * 10}</td> 
                <td>{member.city}</td>
                 <td>
                    {member?.coordinatorNames?.length > 0
                        ? member.coordinatorNames.map(c => c.name).join(', ')
                        : "-"}
                </td>
                <td>
                    {member?.coordinatorNames?.length > 0
                        ? member.coordinatorNames.map(c => c.mobile).join(', ')
                        : "-"}
                </td>

                   

                <td>
                    <span className="circle">{member?.subscriptionCount ? member.subscriptionCount : '0'}</span>
                </td>
            </tr>
        ));
    } else {
        primeMember = (
            <tr>
                <td colSpan="4" className="text-center">
                    No Data Found...
                </td>
            </tr>
        );
    }

    const handlePageChange = (selectedObject) => {
        getPrimeMembershipList(selectedObject.selected + 1);
    };

    return (
        <div>
            {loading && !primeMemberData.length ? ( 
                <LoaderRoundedWithText />
            ) : (
                <>
                    <Sidebar />
                    <div className="main">
                        <div className="topbar">
                            <Navbar title={'Co-ordinator Prime Membership Count'} />
                        </div>

                        <div className="container mt-4">
                            {/* Search and Reset Section */}
                            <Row className="align-items-start mb-4">
                                <Col md={4}>
                                    <div className="d-flex">
                                        <Form.Control
                                            type="text"
                                            placeholder="Search coordinator name..."
                                            value={searchData}
                                            onChange={(e) => setSearchdata(e.target.value)}
                                            className="me-2"
                                            style={{
                                                borderRadius: '10px',
                                                border: '1px solid #003147',
                                                padding: '10px',
                                            }}
                                        />
                                        <Button
                                            onClick={() => setSearchdata('')}
                                            style={{
                                                backgroundColor: '#003147',
                                                color: 'white',
                                                borderRadius: '10px',
                                                padding: '8px 15px',
                                                margin: '0px 10px'
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </div>
                                </Col>

                                <Col md={8}></Col>
                            </Row>


                            {/* Table Section */}
                            <div className="table-responsive-sm" style={{ maxHeight: 1600, overflowY: 'scroll' }}>
                                <table className="table table-bordered table-hover">
                                    <thead className="table-dark text-center">
                                        <tr>
                                            <th>No.</th>
                                            <th>City</th> 
                                            <th>Coordinator Name(s)</th> 
                                            <th>Contact Number</th>
                                            <th>Prime Membership Count</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {loading && primeMemberData.length > 0 ? (
                                            <tr>
                                                <td colSpan={4}> 
                                                    <LoaderRounded />
                                                </td>
                                            </tr>
                                        ) : (
                                            primeMember
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination */}
                            <div className="d-flex justify-content-left mt-4">
                                <ReactPaginate
                                    nextLabel="Next"
                                    previousLabel="Previous"
                                    pageCount={totalPages}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    containerClassName="pagination"
                                    activeClassName="btn btn-primary"
                                    pageClassName="btn"
                                    previousClassName="btn"
                                    nextClassName="btn"
                                    onPageChange={handlePageChange}
                                    forcePage={page - 1}
                                />

                            </div>

                            {/* Refresh Button */}
                            <div className="d-flex justify-content-center mt-4 mb-3">
                                <Button
                                    className="btn btn-success d-flex align-items-center"
                                    onClick={() => window.location.reload(true)}
                                >
                                    <Icon.ArrowClockwise size={18} className="me-2" />
                                    Refresh
                                </Button>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default CoordinatorPrimeMemberShipCount;